import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchSurveys } from "../redux/actions/surveyActions";
import SurveyGrid from "../components/surveys/SurveyGrid";
import SurveyBuilderModal from "../components/modals/SurveyBuilderModal";
import SingleSurvey from "../components/surveys/SingleSurvey";
import { useIsAdmin } from "../hooks/useIsAdmin";

const Surveys = () => {
    const dispatch = useDispatch();
    const surveys = useSelector((state) => state.survey?.surveys || []);
    const currentOrganisation = useSelector((state) => state.organisation?.currentOrganisation);
    const [showSurveyBuilder, setShowSurveyBuilder] = useState(false);
    const [currentSurvey, setCurrentSurvey] = useState(null);
    const [editingSurvey, setEditingSurvey] = useState(null);
    const isAdmin = useIsAdmin();

    useEffect(() => {
        if (currentOrganisation?._id) {
            dispatch(fetchSurveys(currentOrganisation._id));
        }
    }, [currentOrganisation, dispatch]);

    const handleCreateSurvey = () => {
        setEditingSurvey(null);
        setShowSurveyBuilder(true);
    };

    const handleEditSurvey = (survey) => {
        setEditingSurvey(survey);
        setShowSurveyBuilder(true);
    };

    const handleViewSurvey = (survey) => {
        setCurrentSurvey(survey);
    };

    const handleCloseSurvey = () => {
        setCurrentSurvey(null);
    };

    return (
        <div className="main-section">
            {currentSurvey ? (
                <SingleSurvey
                    survey={currentSurvey}
                    onClose={handleCloseSurvey}
                    onEdit={isAdmin ? () => handleEditSurvey(currentSurvey) : undefined}
                    isAdmin={isAdmin}
                />
            ) : (
                <>
                    <SurveyGrid
                        surveys={surveys}
                        onCreateSurvey={handleCreateSurvey}
                        onViewSurvey={handleViewSurvey}
                        onEditSurvey={handleEditSurvey}
                        isAdmin={isAdmin}
                    />
                    {isAdmin && showSurveyBuilder && (
                        <SurveyBuilderModal
                            survey={editingSurvey}
                            closeModal={() => setShowSurveyBuilder(false)}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default Surveys;

